module.exports = __webpack_public_path__ + "img/select_voucher.90d7ad51.jpg";